import script from "./ProfileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileView.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=6051682f&lang=scss"

const __exports__ = script;

export default __exports__